import {useState} from "react";
import {MapMenu} from "base/component/geo/menu";
import {LayerMenu, TileLayerMenu} from "base/component/geo";
import {useMapProvider} from "sisbagal/map";
import {EditLayer, TileLayer} from "base/map";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {createWmsLayer, createShapefileLayer} from "base/map/DynamicLayerUtils";
import WmsLayerDialog from "./WmsLayerDialog";

const SisbagalMapMenu = () => {
    const {getMenuSections, addExternalLayer} = useMapProvider();
    const [isWmsDialogOpen, setIsWmsDialogOpen] = useState(false);

    const getLayerItem = (layerProvider, index) => {
        if (layerProvider.layer instanceof EditLayer) {
            return null;
        }
        if (
            layerProvider.layer instanceof TileLayer ||
            (layerProvider.layer.isExternal && layerProvider.layer.type === "wms")
        ) {
            return <TileLayerMenu key={index} layerProvider={layerProvider} />;
        }
        return <LayerMenu key={index} layerProvider={layerProvider} />;
    };

    const isSectionVisible = section => {
        return section.providers.some(provider => provider.included === true);
    };

    const handleOpenWmsDialog = () => {
        setIsWmsDialogOpen(true);
    };

    const handleAddWms = (url, layers, name) => {
        const wmsLayer = createWmsLayer(url, layers);
        addExternalLayer(wmsLayer, name, "wms");
    };

    const handleAddShp = event => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = async e => {
            const arrayBuffer = e.target.result;
            try {
                const shpLayer = await createShapefileLayer(arrayBuffer);
                const name = file.name.replace(/\.[^/.]+$/, "") || "SHP Externo";
                addExternalLayer(shpLayer, name, "shp");
            } catch (error) {
                alert(
                    "Erro ao cargar o Shapefile. Asegúrate de que sexa un ficheiro .zip válido."
                );
            }
        };
        reader.readAsArrayBuffer(file);
    };

    return (
        <MapMenu>
            {getMenuSections().map(section => {
                return (
                    isSectionVisible(section) && (
                        <Box sx={{mb: 2}} key={section.name}>
                            <Typography
                                variant="subtitle2"
                                color="primary"
                                sx={{pl: 1, mb: 1, borderBottom: "1px solid lightgrey"}}
                            >
                                {section.name}
                            </Typography>
                            {section.providers.map((layerProvider, index) =>
                                getLayerItem(layerProvider, index)
                            )}
                        </Box>
                    )
                );
            })}
            <Box sx={{mb: 2, p: 1}}>
                <Typography
                    variant="subtitle2"
                    color="primary"
                    sx={{mb: 1, borderBottom: "1px solid lightgrey"}}
                >
                    Capas externas
                </Typography>
                <Button
                    variant="outlined"
                    size="small"
                    fullWidth
                    onClick={handleOpenWmsDialog}
                    sx={{mb: 1}}
                >
                    Engadir WMS
                </Button>
                <Button variant="outlined" size="small" component="label" fullWidth>
                    Engadir Shapefile (.zip)
                    <input type="file" hidden accept=".zip" onChange={handleAddShp} />
                </Button>
            </Box>
            <WmsLayerDialog
                open={isWmsDialogOpen}
                onClose={() => setIsWmsDialogOpen(false)}
                onAdd={handleAddWms}
            />
        </MapMenu>
    );
};

export default SisbagalMapMenu;
